export default ({ request }) => ({
  ecomAmzFtyPurchaseDetailListingApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/listing',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailListingTotalApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/listingTotal',
      method: 'POST',
      data,
      timeout: 1000 * 60 * 2,
    })
  },
  ecomAmzFtyPurchaseDetailDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailUpdateShippedApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/update/shipped',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailShippedApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/shipped',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailUpdateInventoryActionApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/update/inventoryAction',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchaseDetailUpdateShortageApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/purchase/detail/update/shortage',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyPurchasShortageLatestListApi(data = {}) {
    return request({
      url: '/ecom/fty/purchas/shortage/latestList',
      method: 'POST',
      data,
    })
  },
})
